import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// Fail loudly at startup if an environment file still carries placeholder values.
// Without this, a misconfigured build would send every request to an invalid host and
// surface only as confusing network errors deep in the app.
function assertEnvironmentConfigured(): void {
  const unconfigured = Object.entries(environment)
    .filter(([, value]) => typeof value === 'string' && value.startsWith('REPLACE_ME_'))
    .map(([key]) => key);

  if (unconfigured.length) {
    // Name the file that actually supplies these values for the running build.
    // angular.json file-replaces environment.ts with environment.prod.ts for the
    // production configuration and environment.dev.ts for development; a build with
    // neither configuration (e.g. a bare `ng build --configuration=""`) reads
    // environment.ts itself, so don't point at .dev.ts in that case.
    const sourceFile = environment.production
      ? 'environment.prod.ts'
      : 'environment.dev.ts (or environment.ts if building without a configuration)';
    throw new Error(
      `Environment is not configured: ${unconfigured.join(', ')} still hold placeholder ` +
        `values. Fill these in in src/environments/${sourceFile}.`,
    );
  }
}

assertEnvironmentConfigured();

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
